export default {
  catalog_id_placeholder: '№ объявления',
  country: 'Страна',
  region: 'Регион',
  city: 'Город',
  district: 'Район',
  category: 'Категория',
  type: 'Тип',
  subtype: 'Подтип',
  purpose: 'Тип сделки',
  any: 'Любая',
  apply: 'Применить',
  reset: 'Сбросить',
  show: 'Показать фильтр',
  hide: 'Скрыть фильтр',

  purpose_options: {
    sale: 'Продажа',
    rental: 'Аренда (долгосрочная)',
    daily_rent: 'Посуточная аренда',
    //investment: 'Инвестиции',
    //holiday: 'Отдых / Holiday',
    //commercial_use: 'Коммерческое использование',
    //residence: 'Для проживания'
  }
}
